module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Mary-Queen-of-Scots.f6165eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Mary-Queen-of-Scots.jpg
// module id = PnJs
// module chunks = 0